<template>
  <div class="w-full h-64 perspective group" @click="isFlipped = !isFlipped">
    <div
      class="relative w-full h-full flip-card-inner transition-transform duration-500"
      :class="{ 'rotate-y-180': isFlipped, 'group-hover:rotate-y-180': !isFlipped }"
    >
      <!-- Front (Menu Image and Price) -->
      <div
        class="absolute w-full h-full backface-hidden bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden"
      >
        <img
          :src="menu.image"
          :alt="menu.name"
          class="w-full h-full object-cover"
        />
        <div class="absolute top-4 left-4">
          <UBadge color="main" size="lg"> {{ menu.price }}€ </UBadge>
        </div>
        <div class="absolute bottom-4 right-4 flex gap-2">
          <UButton
            :to="`/menus/${menu.id}`"
            color="main"
            variant="solid"
            size="sm"
            @click.stop
          >
            Détails
          </UButton>
        </div>
      </div>

      <!-- Back (Menu Details) -->
      <div
        class="absolute w-full h-full rotate-y-180 backface-hidden bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6"
      >
        <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-4">
          {{ menu.name }}
        </h2>

        <div class="space-y-4">
          <div class="overflow-y-auto max-h-32 pr-2">
            <h3
              class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2"
            >
              Contenu:
            </h3>
            <ul class="text-sm text-gray-700 dark:text-gray-300 space-y-1">
              <li
                v-for="content in menu.menu_content"
                :key="content.id"
                class="flex justify-between"
              >
                <span>{{ content.repas.name }}</span>
                <!-- <span v-if="content.quantity > 1">x{{ content.quantity }}</span> -->
              </li>
            </ul>
          </div>

          <div class="flex flex-col gap-4">
            <div class="flex gap-2">
              <UBadge v-if="menu.is_halal" color="main" variant="subtle">
                Halal
              </UBadge>
              <UBadge v-if="menu.is_vegan" color="main" variant="subtle">
                Vegan
              </UBadge>
            </div>

            <div class="flex gap-2">
              <UButton
                color="main"
                variant="solid"
                size="sm"
                class="flex-1"
                :to="`/menus/${menu.id}`"
                @click.stop
              >
                Personnaliser
              </UButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Menu } from "~/models/menu";

defineProps<{
  menu: Menu;
}>();

const isFlipped = ref(false);
</script>

<style scoped>
.perspective {
  perspective: 1000px;
}

.preserve-3d {
  transform-style: preserve-3d;
}

.backface-hidden {
  backface-visibility: hidden;
}

.rotate-y-180 {
  transform: rotateY(180deg);
}

.flip-card-inner {
  transform-style: preserve-3d;
}
</style>
